import { useContext } from 'react';

import LSCTouchpointData from './LSCTouchpointData';

import { LSCTouchpointStateContext } from './LSCTouchpointContextProvider';

const useLscTouchpointData = () => {
  const [lscTouchpointSearchState, setLscTouchpointSearchState] = useContext(LSCTouchpointStateContext);

  const getLscTouchpoints = (orgUnitId) => {
    return LSCTouchpointData.getLscTouchpoint(orgUnitId, lscTouchpointSearchState, setLscTouchpointSearchState);
  };

  return {
    lscTouchpointSearchState,
    setLscTouchpointSearchState,
    getLscTouchpoints
  };
};

export default useLscTouchpointData;